"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInstallationPanel = getInstallationPanel;

var _preact = require("preact");

var _PanelItems = require("../PanelItems");

var _constants = require("@insided/shared/constants");

var InstallationPanelBody = function InstallationPanelBody(_ref) {
  var isInstalled = _ref.isInstalled,
      onSave = _ref.onSave,
      onClickManage = _ref.onClickManage,
      onClickUninstall = _ref.onClickUninstall;
  return (0, _preact.h)("div", {
    className: "panel-body-container installation__panel_body"
  }, (0, _preact.h)("div", {
    className: "panel-body-title"
  }, "To install Intercom, you'll need to authorize the ", _constants.PLATFORM_INSIDED_NAME, " app to have the following permissions: \"Read and List Articles\", \"Read and write users\" and \"Write conversations\". The best practice is to use a separate account for that, so that if personal accounts would be closed the integration would continue working."), isInstalled ? (0, _preact.h)(_PanelItems.ManageInstallationButtons, {
    onClickManage: onClickManage,
    onClickUninstall: onClickUninstall
  }) : (0, _preact.h)(_PanelItems.ActionButtons, {
    showCancelButton: false,
    onSave: onSave,
    onCancel: function onCancel() {},
    primaryButtonVariantType: "brand",
    primaryButtonText: "Install"
  }));
};

function getInstallationPanel(props) {
  var isInstalled = props.isInstalled,
      onSave = props.onSave,
      onClickManage = props.onClickManage,
      onClickUninstall = props.onClickUninstall;
  return {
    body: (0, _preact.h)(InstallationPanelBody, {
      isInstalled: isInstalled,
      onSave: onSave,
      onClickManage: onClickManage,
      onClickUninstall: onClickUninstall
    }),
    customClass: 'panel__body_without_header'
  };
}